import React, { useMemo } from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { ClockNineIcon, FireIcon, ParentUserIcon } from '@cp/ds/src/icons/career/properties/nannies';
import { NewStarIcon } from '@cp/ds/src/icons/career/properties/newStar';
import { SvgIconComponent } from '@cp/ds';
import { CAREER_IDS_WITH_DEALS } from '@common/const/catalog/item';
import { formatResponseDelay, isNewSitterResume } from '../../../model';
import { ResumeCardStatsProps } from './model';

export const ResumeCardStats: React.FC<ResumeCardStatsProps> = ({ careerId, data }) => {
  const responseDelay = useMemo(() => formatResponseDelay(data.responseDelay), [data.responseDelay]);

  if (isNewSitterResume(data)) {
    return (
      <Stack direction="row" gap={1} sx={{ alignItems: 'center', justifyContent: 'center', p: 1.25 }}>
        <Typography variant="h2">🎉</Typography>
        <Typography variant="body bold">Новый ситтер</Typography>
        <Typography variant="h2">🎉</Typography>
      </Stack>
    );
  }

  const renderItem = (label: React.ReactNode, value: React.ReactNode, icon?: SvgIconComponent) => {
    const Icon = icon;
    return (
      <Stack direction="column" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Stack direction="row" sx={{ alignItems: 'center', flexGrow: 1 }}>
          {Icon ? <Icon height={24} width={24} /> : null}
          {typeof value === 'string' ? <Typography variant="h6 Bold">{value}</Typography> : value}
        </Stack>
        {label ? (
          <Typography sx={{ textAlign: 'center', color: 'gray', mt: 0.25 }} variant="small text bold">
            {label}
          </Typography>
        ) : null}
      </Stack>
    );
  };

  const content = CAREER_IDS_WITH_DEALS.includes(careerId) ? (
    <>
      {renderItem('Лет опыта', data.experience ?? '-', ClockNineIcon)}
      {data.reviewsCount ? renderItem('Отзывов', String(data.reviewsCount), FireIcon) : null /* renderItem('Новый', null, NewStarIcon)*/}
      {/* {renderItem('Часов с детьми', '-', ClockNineIcon)}
      {renderItem('Вернулись', '-', ParentUserIcon)} */}
      {renderItem(
        'Отвечает',
        <Typography sx={{ textAlign: 'center' }} variant="small text bold">
          ~<Typography variant="h6 Bold">{responseDelay[0]}</Typography> <Typography variant="caption bold">{responseDelay[1]}</Typography>
        </Typography>,
      )}
    </>
  ) : (
    <>
      {renderItem('Лет опыта', data.experience ?? '-', ClockNineIcon)}
      {data.reviewsCount ? renderItem('Отзывов', String(data.reviewsCount), FireIcon) : null /* renderItem('Новый', null, NewStarIcon) */}
      {renderItem(
        'Отвечает',
        <Typography sx={{ textAlign: 'center' }} variant="small text bold">
          ~<Typography variant="h6 Bold">{responseDelay[0]}</Typography>
          {responseDelay[1]}
        </Typography>,
      )}
    </>
  );

  const itemsCount = Array.isArray(content.props.children) ? content.props.children.filter((i) => Boolean(i)).length : 0;

  return (
    <Stack direction="row" sx={{ justifyContent: itemsCount && itemsCount < 3 ? 'space-around' : 'space-between', px: 2, pt: 0.5, pb: 1 }}>
      {content}
    </Stack>
  );
};
